import { i18n } from "@/setup/i18n-setup";
import { printHumanFloat } from "../pretty-print";
import { IPriceListProductSupplier } from "@/utils/price-list/price-list-product";
import { IAvailableMongoViewColumn, MongoViewColumn } from "../mongo-view/mongo-view-column";
import { MongoView, MongoViewTypes } from "@/models/mongo-view";

// eslint-disable-next-line max-lines-per-function
export function getDefaultPriceListView():MongoView {
	let view = new MongoView();
	view.Type = MongoViewTypes.PRICE_LISTS;
	view.Columns = [
		new MongoViewColumn({
			Property: "Sku",
			Name: i18n.t("models.friendlyNames.Product.Sku").toString(),
		}),
		new MongoViewColumn({
			Property: "Name",
			Name: i18n.t("models.friendlyNames.Product.Name").toString(),
		}),
		new MongoViewColumn({
			Property: "Suppliers.0.ManufacturerCode",
			Name: i18n.t("models.friendlyNames.ProductSupplier.ManufacturerCode").toString(),
		}),
		new MongoViewColumn({
			Property: "Suppliers.0.CatalogPrice",
			Name: i18n.t("models.friendlyNames.ProductSupplier.CatalogPrice").toString(),
		}),
		new MongoViewColumn({
			Property: "Suppliers.0.NettoPrice",
			Name: i18n.t("models.friendlyNames.Product.BuyNettoPrice").toString(),
		}),
		new MongoViewColumn({
			Property: "SellPrice1",
			Name: i18n.t("models.friendlyNames.Product.SellPrice1").toString(),
		}),
		new MongoViewColumn({
			Property: "SellPrice1WithVat",
			Name: i18n.t("models.friendlyNames.Product.SellPrice1WithVat").toString(),
		}),
		new MongoViewColumn({
			Property: "Suppliers",
			Name: i18n.t("models.friendlyNames.Product.MainSupplier").toString(),
		})
	];
	return view;
}


// eslint-disable-next-line max-lines-per-function
export function getPriceListViewColumns():IAvailableMongoViewColumn[] {
	return [
		{
			viewColumnName: "Sku",
			name: i18n.t("models.friendlyNames.Product.Sku").toString(),
			property: "Sku",
			width: "100px"
		},
		{
			viewColumnName: "Name",
			name: i18n.t("models.friendlyNames.Product.Name").toString(),
			property: "Name",
			width: "300px"
		},
		{
			viewColumnName: "Suppliers.0.ManufacturerCode",
			name: i18n.t("models.friendlyNames.ProductSupplier.ManufacturerCode").toString(),
			property: "Suppliers.0.ManufacturerCode",
			width: "100px"
		},
		{
			viewColumnName: "Suppliers.0.CatalogPrice",
			name: i18n.t("models.friendlyNames.ProductSupplier.CatalogPrice").toString(),
			property: "Suppliers.0.CatalogPrice",
			width: "100px",
			right: true,
			print(value:number):string{
				return printHumanFloat(value);
			}
		},
		{
			viewColumnName: "Suppliers.0.NettoPrice",
			name: i18n.t("models.friendlyNames.Product.BuyNettoPrice").toString(),
			property: "Suppliers.0.NettoPrice",
			width: "140px",
			right: true,
			print(value:number):string{
				return printHumanFloat(value);
			}
		},
		{
			viewColumnName: "SellPrice1",
			name: i18n.t("models.friendlyNames.Product.SellPrice1").toString(),
			property: "SellPrice1",
			width: "100px",
			right: true,
			print(value:number):string{
				return printHumanFloat(value);
			}
		},
		{
			viewColumnName: "SellPrice1WithVat",
			name: i18n.t("models.friendlyNames.Product.SellPrice1WithVat").toString(),
			property: "SellPrice1WithVat",
			width: "150px",
			right: true,
			print(value:number):string{
				return printHumanFloat(value);
			}
		},
		{
			viewColumnName: "Suppliers",
			name: i18n.t("models.friendlyNames.Product.MainSupplier").toString(),
			property: "Suppliers",
			width: "300px",
			print(value:IPriceListProductSupplier[]):string{
				if (!value) return "";
				let foundSupplier = value.find(v=>v.IsMainSupplier);
				if (!foundSupplier || !foundSupplier.Contact) return "";
				return foundSupplier.Contact.getDisplayName();
			}
		}
	];
}